export default __webpack_public_path__ + "static/media/search-icon-white.bb833201.svg";